<template>
  <v-app id="app" :style="cssProps">
    <Appbar />
    <v-main>

      <Alert />
      <Loading v-if="isLoadingResources" />
      <router-view v-else />
      <Loading v-if="isLoading" />

    </v-main>
    <Footer v-if="showFooter" />
    <PromotorTools v-if="showPromotorTools" />
    <WhatsAppButton v-if="showWhatsApp" />

  </v-app>
</template>

<script>
import Alert from './components/Alert.vue';
import Appbar from './components/Appbar.vue';
import Footer from './components/Footer.vue';
import Loading from './components/Loading.vue';
import PromotorTools from './components/PromotorTools.vue';
import WhatsAppButton from './components/WhatsAppButton.vue';


export default {
  name: 'App',
  components: { Appbar, Footer, Loading, Alert, PromotorTools, WhatsAppButton },
  mounted() {
    const path = (this.$route?.path || '').replace(/\/+$/, '');
    if (path == '/urgconecta') return;

    const URL_ICONS = "https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css"
    const existingLink = document.querySelector(`link[href="${URL_ICONS}"]`);

    if (!existingLink) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.async = true;
      link.href = URL_ICONS

      document.head.appendChild(link);
    }
  },
  computed:
  {
    showWhatsApp() {
      const path = (this.$route?.path || '').replace(/\/+$/, '');

      // Fuera de la landing y de todo el flujo de afiliacion de Conecta Nacional
      // (/conecta/locations -> /conecta/contact -> /conecta/form).
      if (path === '/urgconecta') return false;
      if (path === '/conecta' || path.startsWith('/conecta/')) return false;

      return true;
    },
    showFooter() {
      const Path = this.$route.path;
      const ExlcudedPaths = ["/affiliate-1", "/area_protegida_form"];
      return !ExlcudedPaths.includes(Path);
    },
    isLoading() {
      return this.$store.getters["Misc/getLoading"];
    },
    isLoadingResources() {
      return this.$store.getters["Misc/getLoadingResources"];
    },
    showPromotorTools() {
      if (this.$cookies.get("codPromotor")) return true;
      return false;
    },
    cssProps() {
      return {
        "--primary-color": this.$vuetify.theme.themes.light.primary,
        "--secondary-color": this.$vuetify.theme.themes.light.secondary,
        "--accent-color": this.$vuetify.theme.themes.light.accent,
      }
    }
  }
}
</script>

<style>
html,
body {
  font-family: 'Nunito', sans-serif;
}

#app {
  font-family: 'Nunito', sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6,
p,
strong {
  font-family: 'Nunito', sans-serif;
}


#app {
  scroll-behavior: smooth;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  scroll-behavior: smooth;
}

.v-btn {
  text-transform: none !important;
}

.v-btn__content {
  text-transform: none !important;
}

.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot fieldset {
  color: transparent !important;
}

h1 {
  font-style: normal;
  font-weight: 700;
  font-size: 41px;
  line-height: 48px;
  text-align: center;
  color: var(--accent-color);
  margin-bottom: 10px;
}

h2 {
  color: var(--primary-color);
  font-size: 30px;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
}

h3 {
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 16px;
}

p {
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  font-weight: 400;
  margin-top: 10px;
}

.container-step-form h1 + p,
.container-step-form h2 + p,
section h1 + p {
  margin-bottom: 33px;
}

.container-step {

  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 120px;
}

.container-step-form {
  max-width: 700px;
  width: 100%;
}


.container-step-form-actions {
  display: flex;
  gap: 10px;
  margin: 50px 0 0 0;
}

.container-name {
  display: grid;
  align-items: center;
  justify-content: space-between;
  grid-template-columns: 45% 45%;
  gap: 5%;
}

.container-phone {
  display: grid;
  align-items: center;
  grid-template-columns: 30% auto;
  gap: 30px;
}

.container-dni {
  display: grid;
  align-items: center;
  grid-template-columns: 30% auto;
  gap: 30px;
}

.container-piso {
  margin-top: 10px;
  display: grid;
  grid-template-columns: 50% auto;
  gap: 2%;
}

.container-direccion {
  display: grid;
  align-items: center;
  grid-template-columns: 70% 28%;
  gap: 2%;
}

.container-edad {
  text-align: start;
  margin: 15px;
}

.container-edad h3 {
  text-align: start;
  margin: 0;
}

.container-total {
  display: flex;
  justify-content: space-between;
  padding: 15px 11px;
}

.container-total .total-label {

  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: var(--primary-color);
}

.container-total .total-amount {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #000000;
}


.container-payment-methods-button-left {
  width: 50%;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.container-payment-methods-button-right {
  width: 50%;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.container-credit-card {
  display: grid;
  grid-template-columns: 45% 45%;
  gap: 10%;
}

.container-benefits,
.container-services {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 25px;
  margin: 20px 0;
  align-items: center;
}



@media screen and (max-width: 860px) {

  .container-benefits,
  .container-services {
    grid-template-columns: 1fr;
    padding: 0 5vw;
  }

  h1 {
    line-height: normal;
  }
}


@media screen and (max-width: 720px) {
  .container-step {
    display: block;
    min-height: auto;
    margin-bottom: 60px;
    padding-top: 20px;
    padding-bottom: 60px;
  }
}

@media screen and (max-width: 800px) {
  .container-step-form {
    padding: 0px !important;
  }

  .container-step-form-actions {
    flex-direction: column;
  }

  .container-name {
    display: block;
  }

  .container-dni {
    display: block;
  }

  .container-payment-methods-button-left {
    width: 100%;
  }

  .container-payment-methods-button-right {
    width: 100%;
  }

  .container-credit-card {
    display: block;
  }
}

@media screen and (max-width: 320px) {

  .container-step-form-actions {
    flex-direction: column;
  }

  .container-phone {
    display: block;
  }
}
</style>
